import React from 'react'
import '../../skins/ohif.css'
import OhifTopBar from './OhifTopBar'
import OhifSeriesDrawer from './OhifSeriesDrawer'
import OhifFloatingPalette from './OhifFloatingPalette'

/**
 * Shell OHIF (desktop): topbar mínima + drawer series + viewport + floating palette.
 * children = viewport clínico — intocable.
 */
function OhifShell({
  drawerCollapsed,
  planLabel,
  chromeTheme = 'dark',
  isFullscreen,
  toolActive,
  anyOpen,
  showMenu = true,
  onToggleMenu,
  onToggleDrawer,
  onLayout,
  onToggleFullscreen,
  toolExecute,
  onAdvancedAction,
  showRelatedStudies = false,
  onRelatedStudies,
  showWorklist = false,
  onWorklist,
  compareMode = false,
  compareModeEnabled = false,
  onToggleCompareMode,
  showLocalStudies = false,
  onLocalStudies,
  bell,
  explorer,
  onSelectSeries,
  seriesColor,
  autoSelectFirstSeries,
  onAutoShowExplorer,
  explorerPinProps = null,
  onMpr3d,
  onDoseInfo,
  mpr3dAllowed,
  visibleMpr3D,
  children,
}) {
  const shellClass = [
    'udv-ohif-shell',
    drawerCollapsed ? 'is-drawer-collapsed' : '',
  ]
    .filter(Boolean)
    .join(' ')

  const theme =
    chromeTheme === 'brand' || chromeTheme === 'light' ? chromeTheme : 'dark'

  return (
    <div className={shellClass} data-skin="ohif" data-theme={theme}>
      <OhifTopBar
        planLabel={planLabel}
        toolActive={toolActive}
        isFullscreen={isFullscreen}
        showMenu={showMenu}
        anyOpen={anyOpen}
        onToggleMenu={onToggleMenu}
        onToggleDrawer={onToggleDrawer}
        onLayout={onLayout}
        onToggleFullscreen={onToggleFullscreen}
        toolExecute={toolExecute}
        onAdvancedAction={onAdvancedAction}
        showRelatedStudies={!!showRelatedStudies}
        onRelatedStudies={onRelatedStudies}
        showWorklist={!!showWorklist}
        onWorklist={onWorklist}
        compareMode={!!compareMode}
        compareModeEnabled={!!compareModeEnabled}
        onToggleCompareMode={onToggleCompareMode}
        showLocalStudies={!!showLocalStudies}
        onLocalStudies={onLocalStudies}
        bell={bell}
      />
      <div className="udv-ohif-body">
        <aside className="udv-ohif-drawer" aria-label="Series" aria-hidden={!!drawerCollapsed}>
          <OhifSeriesDrawer
            explorer={explorer}
            onSelectSeries={onSelectSeries}
            color={seriesColor}
            autoSelectFirstSeries={autoSelectFirstSeries}
            onAutoShowExplorer={onAutoShowExplorer}
            {...(explorerPinProps || {})}
          />
        </aside>
        <main className="udv-ohif-viewport">
          {children}
          <OhifFloatingPalette
            anyOpen={anyOpen}
            toolActive={toolActive}
            toolExecute={toolExecute}
            onMpr3d={onMpr3d}
            onDoseInfo={onDoseInfo}
            mpr3dAllowed={mpr3dAllowed}
            visibleMpr3D={visibleMpr3D}
          />
        </main>
      </div>
    </div>
  )
}

export default OhifShell
